
export const NavSeparator = () => (
  <div className="h-px bg-slate-200 my-3 mx-2" />
);
